import { render, staticRenderFns } from "./AutoTaggingModal.vue?vue&type=template&id=18a7833a&scoped=true&"
import script from "./AutoTaggingModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AutoTaggingModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AutoTaggingModal.vue?vue&type=style&index=0&id=18a7833a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7833a",
  null
  
)

export default component.exports